import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { __, _i } from "../../utils";
import { List, Space, Spin, App, Tooltip } from "antd";
import { ClockCircleOutlined, CloudServerOutlined, CloudUploadOutlined } from "@ant-design/icons";
import { PluginUpdateLicenseTelemetryDataModal } from ".";
import { copyToClipboard } from "@devowl-wp/react-utils";
const PluginUpdateLicenseListItem = observer((param)=>{
    let { license, onDeactivate } = param;
    const { message } = App.useApp();
    const { busy, uuid, installationType, telemetryDataSharingOptIn, blogName, code, remote, programmatically, host, blog, store: { needsLicenseKeys } } = license;
    return /*#__PURE__*/ _jsx(Spin, {
        spinning: busy,
        children: /*#__PURE__*/ _jsxs(List.Item, {
            style: {
                paddingLeft: 0,
                paddingRight: 0
            },
            actions: [
                needsLicenseKeys && /*#__PURE__*/ _jsxs(Space, {
                    children: [
                        /*#__PURE__*/ _jsx(Tooltip, {
                            title: __("Client UUID: %s, click to copy.", uuid),
                            children: /*#__PURE__*/ _jsx(CloudServerOutlined, {
                                style: {
                                    cursor: "pointer"
                                },
                                onClick: ()=>{
                                    copyToClipboard(uuid);
                                    message.success("Successfully copied client UUID key to clipboard!");
                                }
                            })
                        }),
                        installationType === "production" ? __("Production") : installationType === "development" ? __("Development") : "n/a"
                    ]
                }, "installationType"),
                remote && /*#__PURE__*/ _jsxs(Space, {
                    children: [
                        /*#__PURE__*/ _jsx(ClockCircleOutlined, {}),
                        __("Activated %s", new Date(remote.licenseActivation.activatedAt).toLocaleString(document.documentElement.lang))
                    ]
                }, "activatedAt"),
                /*#__PURE__*/ _jsx(PluginUpdateLicenseTelemetryDataModal, {
                    license: license,
                    disabled: !telemetryDataSharingOptIn,
                    children: /*#__PURE__*/ _jsxs(Space, {
                        style: {
                            cursor: "pointer"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(CloudUploadOutlined, {}),
                            telemetryDataSharingOptIn ? __("Telemetry data sharing enabled") : __("Telemetry data sharing disabled")
                        ]
                    }, "telemetryDataSharingOptIn")
                }, "telemetryModal"),
                !programmatically && /*#__PURE__*/ _jsx("a", {
                    className: "button-link",
                    onClick: async ()=>{
                        try {
                            await license.deactivate();
                        } catch (e) {
                            message.error(e.responseJSON.message);
                        }
                        onDeactivate == null ? void 0 : onDeactivate(license);
                    },
                    children: __("Deactivate")
                }, "deactivate")
            ].filter(Boolean),
            children: [
                /*#__PURE__*/ _jsx(List.Item.Meta, {
                    title: blogName,
                    description: needsLicenseKeys ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            __("Your license key"),
                            ": ",
                            /*#__PURE__*/ _jsx("code", {
                                children: code
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            __("Your installation is fully activated."),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    marginTop: 15
                                },
                                children: /*#__PURE__*/ _jsx("a", {
                                    rel: "noreferrer",
                                    href: __("https://devowl.io/knowledge-base/real-cookie-banner-upgrade-free-to-pro-version/"),
                                    className: "button",
                                    target: "_blank",
                                    children: __("Enter license key to unlock PRO features")
                                })
                            })
                        ]
                    })
                }),
                programmatically && /*#__PURE__*/ _jsx("div", {
                    className: "notice notice-info inline below-h2 notice-alt",
                    style: {
                        margin: "0 0 10px 0"
                    },
                    children: /*#__PURE__*/ _jsx("p", {
                        children: _i(__("This license cannot be deactivated manually because it is configured programmatically. That means you have used the {{a}}activation filter{{/a}} for host {{code}}%s{{/code}} (Blog ID: %d). Please remove the filter to deactivate the license!", host, blog), {
                            code: /*#__PURE__*/ _jsx("code", {}),
                            a: /*#__PURE__*/ _jsx("a", {
                                href: "https://docs.devowl.io/real-cookie-banner/hooks/DevOwl_RealProductManager_License_Programmatic_$slug.html",
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        })
                    })
                })
            ]
        })
    });
});
export { PluginUpdateLicenseListItem };
